module.exports = __webpack_public_path__ + "img/woman_juggling.20c03324.gif";